import React, { useContext, useEffect, useState } from "react";
import Image from "next/image";
import { useRouter } from "next/router";
import Link from "next/link";
import styles from "./styles";
import Fuse from "fuse.js";
import { getDocByType } from "../../../helpers/PrismicKnowledgeHub";
import { StorefrontContext } from "../../../providers/storefront";

const KnowledgeHubHeader = ({ isNotMainPage, description }) => {
  const {
    openSearch,
    setOpenSearch,
    filteredResults,
    setFilteredResults,
    searchInput,
    setSearchInput,
    setSelectedDiscussion,
  } = useContext(StorefrontContext);

  const [topics, setTopics] = useState([]);
  const [discussions, setDiscussions] = useState([]);
  const [posts, setPosts] = useState([]);
  const router = useRouter();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const temp = await getDocByType("post");
        const temp2 = await getDocByType("discussion");
        const temp3 = await getDocByType("topic");
        setPosts(temp);
        setDiscussions(temp2);
        setTopics(temp3);
      } catch (error) {
        console.error("Error fetching:", error);
      }
    };

    fetchData();
  }, []);

  const getTopicUid = (post) => {
    if (post) {
      const temp = discussions.find((d) => {
        const temp2 = post.data.discussions_group?.find((postDisc) => {
          if (postDisc.discussion_link.uid === d.uid) {
            return postDisc;
          }
        });

        return temp2;
      });
      return temp;
    }
  };

  useEffect(() => {
    const options = {
      includeScore: true,
      keys: ["data.title", "data.discussion_title", "data.topic_title"],
      threshold: 0.5,
    };

    const fuse = new Fuse([...posts, ...discussions, ...topics], options);

    const results = fuse.search(searchInput);

    setFilteredResults(results.map((result) => result.item));
  }, [searchInput, isNotMainPage, posts, topics, discussions]);

  const handleOpenSearch = () => {
    setOpenSearch(true);
  };

  const handleCloseSearch = () => {
    setOpenSearch(false);
  };

  const handleClearInput = () => {
    setSearchInput("");
    handleCloseSearch();
    setFilteredResults([]);
  };

  const handleExitPreviewMode = () => {
    if (router.isPreview) {
      window.location.href = "/api/exit-preview";
    }
  };

  return (
    <>
      <div
        className={isNotMainPage ? "header-wrapper-change" : "header-wrapper"}
      >
        <div
          className={isNotMainPage ? "title-section-change" : "title-section"}
        >
          <div className={isNotMainPage ? "nav-logo-change" : "nav-logo"}>
            <Link
              legacyBehavior
              href={isNotMainPage ? "/" : "https://aftershockpc.com.au"}
            >
              <a onClick={isNotMainPage ? null : handleExitPreviewMode}>
                <Image
                  draggable={false}
                  src="https://cdn.shopify.com/s/files/1/0522/3320/7988/files/header_logo_5d52404a-f89d-4a2b-a73e-7b79d8dd8640.svg?v=1723189737"
                  alt="Aftershock logo"
                  width={167}
                  height={36}
                  layout="fixed"
                />
              </a>
            </Link>
          </div>
          <h1 className={isNotMainPage ? "title-change" : "title"}>
            How can we help?
          </h1>
          {description && (
            <p className={isNotMainPage ? "description-change" : "description"}>
              {description}
            </p>
          )}
          <div
            className={
              (isNotMainPage ? "input-section-change" : "input-section") +
              (openSearch ? " openSearch" : "")
            }
            id="closeSearch"
          >
            <div className="icon-search">
              <Image
                draggable={false}
                src="https://cdn.shopify.com/s/files/1/0522/3320/7988/files/search-icon.png?v=1723189761"
                alt="icon-search"
                width={36}
                height={28}
                loading="lazy"
              />
            </div>
            <input
              value={searchInput}
              onChange={(e) => {
                setSearchInput(e.target.value);
              }}
              className="input-search"
              type="text"
              placeholder={
                isNotMainPage ? "Search for Guides" : "Browse help topics"
              }
            />
            {searchInput && (
              <div className="clear-button" onClick={handleClearInput}>
                <Image
                  draggable={false}
                  src="https://cdn.shopify.com/s/files/1/0522/3320/7988/files/icon-close.png?v=1714038756"
                  alt="icon-search"
                  width={24}
                  height={24}
                  loading="lazy"
                />
              </div>
            )}
          </div>
          {!isNotMainPage && searchInput && filteredResults.length > 0 && (
            <div className="search-results-topics">
              {filteredResults.map((res) => {
                let title = "";
                if (res.type === "topic") {
                  title = res.data.topic_title;
                } else if (res.type === "discussion") {
                  title = res.data.discussion_title;
                } else {
                  title = res.data.title;
                }
                return (
                  <Link
                    href={
                      res.type === "topic"
                        ? `/${res.uid}`
                        : res.type === "post"
                        ? `/${
                            getTopicUid(res)?.data.topics[0].topic_link.uid
                          }/${res.uid}`
                        : `/${res.data.topics[0].topic_link.uid}`
                    }
                    key={res.uid}
                  >
                    <div
                      className="search-results-item"
                      onClick={() => {
                        handleClearInput();
                        setFilteredResults([]);
                        if (res.type === "post") {
                          const discussion = discussions.find(
                            (dics) =>
                              dics.uid ===
                              res.data.discussions_group[0].discussion_link.uid
                          );
                          setSelectedDiscussion(discussion);
                        }
                      }}
                    >
                      <span>{title}</span>
                    </div>
                  </Link>
                );
              })}
            </div>
          )}
          {isNotMainPage && searchInput && (
            <div className="search-results-posts">
              <div className="search-results-posts-wrapper">
                <div className="search-results-posts-list">
                  {filteredResults.map((res) => {
                    let title = "";
                    if (res.type === "topic") {
                      title = res.data.topic_title;
                    } else if (res.type === "discussion") {
                      title = res.data.discussion_title;
                    } else {
                      title = res.data.title;
                    }

                    return (
                      <Link
                        href={
                          res.type === "topic"
                            ? `/${res.uid}`
                            : res.type === "post"
                            ? `/${
                                getTopicUid(res)?.data.topics[0].topic_link.uid
                              }/${res.uid}`
                            : `/${res.data.topics[0].topic_link.uid}`
                        }
                        key={res.uid}
                      >
                        <div
                          className="search-results-item"
                          onClick={() => {
                            handleClearInput();
                            setFilteredResults([]);
                            if (res.type === "post") {
                              const discussion = discussions.find(
                                (dics) =>
                                  dics.uid ===
                                  res.data.discussions_group[0].discussion_link
                                    .uid
                              );
                              setSelectedDiscussion(discussion);
                            }
                          }}
                        >
                          <span>{title}</span>
                        </div>
                      </Link>
                    );
                  })}
                </div>
              </div>
            </div>
          )}
          {!openSearch && isNotMainPage && (
            <div
              className="input-section-mobile"
              onClick={handleOpenSearch}
              id="openSearch"
            >
              <Image
                draggable={false}
                src="https://cdn.shopify.com/s/files/1/0522/3320/7988/files/iconamoon_search-light.png?v=1723189895"
                alt="icon-search"
                width={30}
                height={30}
                loading="lazy"
              />
            </div>
          )}
        </div>
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default KnowledgeHubHeader;
